if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      var status = 'more';
      const button = this.querySelector('[data-toggle-button]');
      const button_text = button.dataset;
      const line_clamp_class = button.dataset.class || 'line-clamp-3';
      button.addEventListener('click', () => {
        if (status == 'more') {
          this.querySelector('[data-description-clamp]').classList.remove(line_clamp_class);
          button.innerText = button_text.readLess;
          status = 'less';
        } else if (status == 'less') {
          this.querySelector('[data-description-clamp]').classList.add(line_clamp_class);
          button.innerText = button_text.readMore;
          status = 'more';
        }
      });
    }
  }

  window.ReadMore = ReadMore;

  customElements.define('read-more', ReadMore);
}
